import * as React from "react";
import { parse, isPast, getUnixTime } from "date-fns";
import _ from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { loginWithRedirect } from "../../actions/user";
import useAsyncState from "../../hooks/useAsyncState";
import Store from "../../store";
import checkIfTicketForSale from "../../utils/checkIfTicketForSale";
import checkIfTicketInFuture from "../../utils/checkIfTicketInFuture";
import getContentReferenceTileProps from "../../utils/getContentReferenceTileProps";
import { maybePluralize } from "../../utils/stringHandler";

import UTSLogoSm from "../../../assets/images/activateuts-logo-sm.png";
import LogoPlaceholder from "../../../assets/images/logo-placeholder.png";
import RichTextContent from "../molecules/RichTextContent";
import LinkHandler from "../atoms/LinkHandler";
import Accordions from "./Accordions";
import Config from "../../constants/Config";
import Button from "../atoms/Button";
import TextButton from "../atoms/TextButton";
import ServerErrorMessage from "../atoms/ServerErrorMessage";
import Image from "../atoms/Image";
import CategorySection from "../molecules/CategorySection";
import GetTicketsModal from "./GetTicketsModal";
import Pill from "../atoms/Pill";
import TileRow from "./TileRow";
import Sponsors from "../molecules/Sponsors";
import Tile from "../molecules/Tile";
import qs from "query-string";
import { useLocation } from "react-router-dom";

type PropsType = {
    acf: any;
    events: any;
    categories?: any;
    event_club_logos: any;
    event_ticket_comment_label?: string;
    post_title: string;
    ID: number;
    related: any;
    isProgramOfEvents?: boolean;
    slug: string;
    event_host_type_data:
        | {
              name: string;
              imageUrl: string;
              link: string;
          }
        | undefined;
};

const HostItem = (props: any) => {
    const { default_tile_image } = useSelector(
        (state: any): any => state.options
    );

    return (
        <div className="col-xs-6 col-md-4 event-detail-body__host__item">
            <LinkHandler
                className="event-detail-body__host__item__inner"
                to={`/clubs/${props.host.post_name}`}
                target=""
            >
                <div className="event-detail-body__host__item__image">
                    <Image
                        src={props.logo ? props.logo : LogoPlaceholder}
                        alt=""
                        aspectRatio="1:1"
                    />
                </div>
                <div className="event-detail-body__host__item__name">
                    {props.host.post_title}
                </div>
            </LinkHandler>
        </div>
    );
};

const TicketsContent = (props: any) => {
    const location = useLocation();
    const queries = qs.parse(location.search);
    const dispatch = useDispatch();
    const [state] = useAsyncState();
    const [showGetTicketsModal, setShowGetTicketsModal] = React.useState(false);
    const { loggedIn, purchasedEvents } = useSelector(
        (state: any): any => state.user
    );
    const eligibleForTickets =
        props.tickets.some(ticket => ticket.acf.eligible_for === "public") ||
        loggedIn;

    const dates = {
        startsAt: parse(props.start_date, "dd/MM/yyyy h:mm aa", new Date()),
        endsAt: parse(props.end_date, "dd/MM/yyyy h:mm aa", new Date()),
    };

    const userHasTicketsAlready =
        loggedIn &&
        purchasedEvents &&
        purchasedEvents.length &&
        purchasedEvents.includes(props.id);

    const handleLoginToJoin = () => {
        dispatch(loginWithRedirect(document.location.pathname));
    };

    const allTicketsSoldOut = !props.tickets?.some(ticket => {
        return checkIfTicketForSale(ticket, props.status);
    });

    return (
        <div className="event-detail-body__event-ticket">
            <div className="event-detail-body__event-ticket__inner">
                <h2 className="event-detail-body__event-ticket__title">
                    Tickets
                </h2>

                {props.tickets && props.tickets.length ? (
                    <>
                        <p className="event-detail-body__event-ticket__description">
                            {props.description}
                        </p>

                        <div className="event-detail-body__event-ticket__details">
                            {props.tickets &&
                                props.tickets.map((ticket, index) => {
                                    if (
                                        ticket.type &&
                                        !checkIfTicketInFuture(ticket)
                                    ) {
                                        const ticketNameMeta =
                                            ticket.meta_data.find(
                                                data =>
                                                    data.key ===
                                                    "crm_ticket_name"
                                            );
                                        const ticketName = ticketNameMeta
                                            ? ticketNameMeta.value
                                            : ticket.type;

                                        return (
                                            <div
                                                key={index}
                                                className="event-detail-body__event-ticket__details__row"
                                            >
                                                <div className="event-detail-body__event-ticket__details__position">
                                                    {ticketName}

                                                    {!checkIfTicketForSale(
                                                        ticket,
                                                        props.status
                                                    ) ? (
                                                        <Pill
                                                            color="dark-grey"
                                                            inverted
                                                        >
                                                            Sold out
                                                        </Pill>
                                                    ) : null}
                                                </div>
                                                <div className="event-detail-body__event-ticket__details__duration">
                                                    ${ticket.price}
                                                </div>
                                            </div>
                                        );
                                    }
                                    return null;
                                })}
                        </div>

                        {/* User already has tickets banner */}
                        {userHasTicketsAlready ? (
                            <div className="event-detail-body__have-tickets">
                                You have ticket(s) to this event.
                                <br />
                                <TextButton to={Config.routes.incomingTickets}>
                                    Go to tickets
                                </TextButton>
                            </div>
                        ) : null}

                        <ServerErrorMessage>{state.error}</ServerErrorMessage>
                        {isPast(dates.endsAt) ? (
                            <Button
                                className="button button--green event-detail-body__cta"
                                styles={[]}
                                disabled
                            >
                                Event finished
                            </Button>
                        ) : props.status === "cancelled" ? (
                            <Button
                                className="button button--green event-detail-body__cta"
                                styles={[]}
                                disabled
                            >
                                Event cancelled
                            </Button>
                        ) : props.sold_out || allTicketsSoldOut ? (
                            <Button
                                className="button button--green event-detail-body__cta"
                                styles={[]}
                                disabled
                            >
                                Tickets have sold out
                            </Button>
                        ) : eligibleForTickets ? (
                            <React.Fragment>
                                <Button
                                    loading={state.loading}
                                    success={!!state.success}
                                    className="button button--green event-detail-body__cta"
                                    styles={[]}
                                    onClick={() => setShowGetTicketsModal(true)}
                                >
                                    {userHasTicketsAlready
                                        ? "Get more tickets"
                                        : "Get tickets"}
                                </Button>
                                <GetTicketsModal
                                    onClose={() =>
                                        setShowGetTicketsModal(false)
                                    }
                                    heading={props.heading}
                                    active={showGetTicketsModal}
                                    tickets={props.tickets.filter(
                                        ticket => !checkIfTicketInFuture(ticket)
                                    )}
                                    event_ticket_comment_label={
                                        props.event_ticket_comment_label
                                    }
                                    path={props.slug}
                                    previewId={
                                        queries.preview &&
                                        (queries.preview_id ||
                                            queries.p ||
                                            queries.page_id)
                                            ? queries.preview_id ||
                                              queries.p ||
                                              queries.page_id
                                            : undefined
                                    }
                                />
                            </React.Fragment>
                        ) : (
                            <Button
                                className="button button--green event-detail-body__cta"
                                styles={[]}
                                onClick={handleLoginToJoin}
                            >
                                Login or sign up to get tickets
                            </Button>
                        )}
                    </>
                ) : props.ticket_external_link ? (
                    <>
                        <p className="event-detail-body__event-ticket__description">
                            {props.description}
                        </p>
                        {props.sold_out ? (
                            <Button
                                className="button button--green event-detail-body__cta"
                                styles={[]}
                                disabled
                            >
                                Tickets have sold out
                            </Button>
                        ) : (
                            <Button
                                to={props.ticket_external_link}
                                target="_blank"
                                iconAfter="ticket-external-link"
                                styles={["green"]}
                            >
                                Get tickets
                            </Button>
                        )}
                    </>
                ) : (
                    <p className="event-detail-body__event-ticket__description">
                        This is a ticketless event. No registration is required.
                    </p>
                )}
            </div>
        </div>
    );
};

const EventDetailBody = (props: PropsType) => {
    const state = Store.getState();
    const related = _.get(state, `page.related`) || {};
    const tickets = props.acf.event_products
        ? props.acf.event_products.map(product => {
              return {
                  ...related[product.product.ID],
                  ...product,
              };
          })
        : [];

    const childEvents =
        props.acf.linked_events && props.acf.linked_events.length
            ? props.acf.linked_events
                  .map(eventId => {
                      return {
                          ...related[eventId],
                      };
                  })
                  .filter(function (item) {
                      return item.acf;
                  })
                  .map(event => {
                      let sortDate = getUnixTime(
                          parse(
                              event.acf.end_date,
                              "dd/MM/yyyy h:mm aa",
                              new Date()
                          )
                      );
                      if (getUnixTime(new Date()) > sortDate) {
                          sortDate += 10 * 365 * 24 * 60 * 60;
                      }

                      event.sortDate = sortDate;
                      return event;
                  })
                  .sort((a, b) => a.sortDate - b.sortDate)
            : [];
    let lengthOfChildEvents =
        childEvents && childEvents.length ? childEvents.length : 0;
    const adEventIndex = Math.min(lengthOfChildEvents, 2);
    if (
        props.acf.event_listing &&
        props.acf.event_listing.ad_tile &&
        related[props.acf.event_listing.ad_tile["ID"]]
    ) {
        childEvents.splice(
            adEventIndex,
            0,
            related[props.acf.event_listing.ad_tile["ID"]]
        );
    }
    const eventsListTitle =
        (props.acf &&
            props.acf.event_listing &&
            props.acf.event_listing.event_listing_title) ||
        maybePluralize(lengthOfChildEvents, "event");
    return (
        <div
            className={`event-detail-body ${
                props.isProgramOfEvents ? "event-detail-body--full-width" : ""
            }`}
        >
            <div className="event-detail-body__container container-fluid">
                <div className="event-detail-body__row row">
                    <div
                        className={`${
                            !props.isProgramOfEvents
                                ? "col-xs-12 col-md-8"
                                : "col-xs-12 col-md-10 col-md-offset-1"
                        }`}
                    >
                        <div className="event-detail-body__left-content">
                            <div className="row">
                                {props.event_host_type_data ||
                                props.acf.hosted_by.length > 0 ? (
                                    <div className="col-xs-12">
                                        <div className="row event-detail-body__host__row">
                                            <div className="col-xs-12">
                                                <div className="row">
                                                    <div className="col-xs-12">
                                                        <div className="event-detail-body__host__title">
                                                            Hosted by
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row event-detail-body__host__inner">
                                                    <div className="col-xs-12 col-md-10">
                                                        <div className="row">
                                                            {props.event_host_type_data && (
                                                                <div className="col-xs-6 col-md-4 event-detail-body__host__item">
                                                                    <a
                                                                        className="event-detail-body__host__item__inner"
                                                                        href={
                                                                            props
                                                                                .event_host_type_data
                                                                                .link
                                                                        }
                                                                    >
                                                                        <div className="event-detail-body__host__item__image">
                                                                            <Image
                                                                                src={
                                                                                    props
                                                                                        .event_host_type_data
                                                                                        .imageUrl
                                                                                }
                                                                                alt=""
                                                                                aspectRatio="1:1"
                                                                            />
                                                                        </div>
                                                                        <div className="event-detail-body__host__item__name">
                                                                            {
                                                                                props
                                                                                    .event_host_type_data
                                                                                    .name
                                                                            }
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            )}
                                                            {props.acf.hosted_by
                                                                ? props.acf.hosted_by.map(
                                                                      host => {
                                                                          const logo =
                                                                              props.event_club_logos.filter(
                                                                                  logo =>
                                                                                      logo.id ===
                                                                                      host.ID.toString()
                                                                              )[0]
                                                                                  .logo;

                                                                          return (
                                                                              <HostItem
                                                                                  key={
                                                                                      host.post_title
                                                                                  }
                                                                                  host={
                                                                                      host
                                                                                  }
                                                                                  logo={
                                                                                      logo
                                                                                  }
                                                                              />
                                                                          );
                                                                      }
                                                                  )
                                                                : null}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xs-12 col-md-11">
                                                        <hr />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : null}
                                <div className="col-xs-12">
                                    <RichTextContent
                                        html={props.acf.html}
                                        background={false}
                                        theme="purple"
                                        className="event-detail-body__main-description"
                                    />
                                </div>

                                {props.isProgramOfEvents ? (
                                    <div className="col-xs-12">
                                        {childEvents && childEvents.length ? (
                                            <div className="event-detail-body__program-events">
                                                <h2 className="heading-2">
                                                    {eventsListTitle}
                                                </h2>
                                                <div className="row">
                                                    {childEvents.map(
                                                        (tile, tileIndex) => {
                                                            const post_type =
                                                                props.acf
                                                                    ?.event_listing
                                                                    ?.ad_tile[
                                                                    "ID"
                                                                ] &&
                                                                tileIndex ===
                                                                    adEventIndex
                                                                    ? "ad"
                                                                    : "event";
                                                            return (
                                                                <div
                                                                    key={
                                                                        tileIndex
                                                                    }
                                                                    className="col-xs-6 col-sm-4"
                                                                >
                                                                    <Tile
                                                                        key={
                                                                            tileIndex
                                                                        }
                                                                        {...getContentReferenceTileProps(
                                                                            {
                                                                                ...tile,
                                                                                post_type,
                                                                            }
                                                                        )}
                                                                    />
                                                                </div>
                                                            );
                                                        }
                                                    )}
                                                </div>
                                            </div>
                                        ) : null}

                                        {props.acf.tile_row &&
                                        props.acf.tile_row.tiles ? (
                                            <div className="event-detail-body__tile-row">
                                                <TileRow
                                                    title={
                                                        props.acf.tile_row.title
                                                    }
                                                    description={
                                                        props.acf.tile_row
                                                            .description
                                                    }
                                                    tiles={
                                                        props.acf.tile_row.tiles
                                                    }
                                                />
                                            </div>
                                        ) : null}

                                        {props.acf.icons_sponsors ? (
                                            <div className="event-detail-body__icon-row">
                                                <Sponsors
                                                    icons={
                                                        props.acf.icons_sponsors
                                                    }
                                                    title="Sponsors"
                                                    target="_blank"
                                                />
                                            </div>
                                        ) : null}
                                    </div>
                                ) : null}

                                <div className="col-xs-12 event-detail-body__faq">
                                    {props.acf.faqs &&
                                    props.acf.faqs.sections.length > 0 ? (
                                        <Accordions
                                            title={props.acf.faqs.title}
                                            description={
                                                props.acf.faqs.description
                                            }
                                            accordions={props.acf.faqs.sections}
                                        />
                                    ) : null}
                                </div>
                                <div className="col-xs-12">
                                    {props.categories ? (
                                        <CategorySection
                                            categories={props.categories}
                                            title="Event category"
                                            type="event"
                                            section="bottom-content"
                                        />
                                    ) : null}
                                </div>

                                {/* Terms and conditions */}
                                {props.acf.terms_conditions ? (
                                    <div className="col-xs-12">
                                        <div className="event-detail-body__terms">
                                            <h4 className="event-detail-body__terms__heading">
                                                Terms and conditions
                                            </h4>
                                            <RichTextContent
                                                html={
                                                    props.acf.terms_conditions
                                                }
                                                className="event-detail-body__terms__content"
                                            />
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>

                    {!props.isProgramOfEvents ? (
                        <div className="col-xs-12 col-md-4">
                            <TicketsContent
                                id={props.ID}
                                description={props.acf.tickets_marketing_copy}
                                heading={props.post_title}
                                event_ticket_comment_label={
                                    props.acf.event_ticket_comment_label
                                }
                                tickets={tickets}
                                ticket_external_link={
                                    props.acf.ticket_external_link
                                }
                                sold_out={props.acf.sold_out}
                                status={props.acf.open_state}
                                end_date={props.acf.end_date}
                                slug={props.slug}
                            />
                            {props.categories ? (
                                <CategorySection
                                    categories={props.categories}
                                    title="Event category"
                                    type="event"
                                    section="left-content"
                                />
                            ) : null}
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

EventDetailBody.defaultProps = {
    heroTitleSize: "heading-1",
    showRelated: true,
};

export default EventDetailBody;
